import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-detail",
  "use": "icon-detail-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-detail\"><path d=\"M911.68 0H111.68a64 64 0 0 0-64 64v896a64 64 0 0 0 64 64h800a64 64 0 0 0 64-64V64a64 64 0 0 0-64-64z m0 960H111.68V64h800z\" fill=\"\" p-id=\"1278\" /><path d=\"M271.68 304.64h472a32 32 0 1 0 0-64H271.68a32 32 0 0 0 0 64zM271.68 539.52h408.64a32 32 0 0 0 0-64H271.68a32 32 0 1 0 0 64zM271.68 737.92h376.64a32 32 0 1 0 0-64H271.68a32 32 0 0 0 0 64z\" fill=\"\" p-id=\"1279\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol